/**
 * Class LinkCardsGrid
 */
class LinkCardsGrid {
	grid: JQuery;

	constructor(element: JQuery) {
		this.grid = element;
		this.init();
	}

	/**
	 * Initialize
	 */
	init() {
		this.filterElementsByGroup();
	}

	// クエリパラメータをオブジェクトとして取得するユーティリティ関数
	getQueryParams(): Record<string, string[]> {
		const queryParams: Record<string, string[]> = {};
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		urlParams.forEach((value, key) => {
			if (!queryParams[key]) {
				queryParams[key] = [];
			}
			queryParams[key].push(value);
		});

		return queryParams;
	}

	// groupフィルタに基づいて要素を表示/非表示
	filterElementsByGroup() {
		const queryParams = this.getQueryParams();
		const groupFilters = queryParams["group"];
		const elements = document.querySelectorAll<HTMLElement>(
			"#js_group_grid .block-link-cards-grid__card-wrapper",
		);

		if (groupFilters) {
			elements.forEach((element) => {
				const group = (element as HTMLElement).getAttribute("data-group");
				if (group && groupFilters.includes(group)) {
					(element as HTMLElement).style.display = ""; // 表示
				} else {
					(element as HTMLElement).style.display = "none"; // 非表示
				}
			});
		}
	}
}

// クラスインスタンスの作成
const linkCardsGrid: LinkCardsGrid[] = [];
$("#js_group_grid").each(function () {
	const linkCardsGridInstance = new LinkCardsGrid($(this));
	linkCardsGrid.push(linkCardsGridInstance);
});
